export const CHAT_RESPONSE_DEBOUNCE_MS = 3000;
export const QUILT_SUGGESTED_QUESTION_COUNT = 4;
